import { FaCheckCircle, FaUsers } from "react-icons/fa";
import Footerlanding from '../landing/Footerlanding';
import Navbarlanding from '../landing/Navbarlanding';

import "../css/ServiceNav.css"; // updated CSS file

const services = [
  { 
    title: "Personal Loan", 
    desc: "Quick approval for your immediate personal financial needs.", 
    benefits: ["Minimal paperwork", "Flexible repayment tenure"], 
    interest: "10-15% p.a." 
  },
  { 
    title: "Home Loan", 
    desc: "Achieve your dream of owning a home with easy financing.", 
    benefits: ["Low down payment", "Attractive long tenure"], 
    interest: "7-12% p.a." 
  },
  { 
    title: "Car Loan", 
    desc: "Drive home your dream car with our low-interest solutions.", 
    benefits: ["Fast processing", "Affordable EMI options"], 
    interest: "8-13% p.a." 
  },
  { 
    title: "Business Loan", 
    desc: "Empower your business with flexible and quick financing.", 
    benefits: ["Collateral-free options", "Instant disbursal"], 
    interest: "9-16% p.a." 
  },
  { 
    title: "Education Loan", 
    desc: "Invest in your future without the stress of immediate funds.", 
    benefits: ["Global study support", "Repayment after graduation"], 
    interest: "8-12% p.a." 
  },
  { 
    title: "Vehicle Loan", 
    desc: "Finance your two-wheeler or commercial vehicle easily.", 
    benefits: ["Up to 90% financing", "Simple documentation"], 
    interest: "9-14% p.a." 
  },
  { 
    title: "Product Loan", 
    desc: "Buy the latest gadgets and appliances on easy EMIs.", 
    benefits: ["No-cost EMI options", "Instant credit limit"], 
    interest: "Varies by product" 
  },
  { 
    title: "Insurance Plans", 
    desc: "Secure your family's future with comprehensive coverage.", 
    benefits: ["Life & health protection", "Tax benefits under 80C"], 
    interest: "Fixed Premiums" 
  },
  { 
    title: "Investment Plans", 
    desc: "Maximize your savings with smart wealth management.", 
    benefits: ["Diversified portfolio", "Expert financial advice"], 
    interest: "Market Linked" 
  }
];

const ServicePage = () => {
    return (
        <div className="service-page-container">
            {/* Header / Navbar */}
            <Navbarlanding />

            {/* Hero Section */}
            <section className="service-hero">
                <div className="hero-inner">
                    <div className="hero-left">
                        <h1>Discover Our Financial Solutions</h1>
                        <p>Your dedicated team helping you achieve financial freedom.</p>
                        <button className="btn-primary">Contact Us</button>
                        <div className="social-proof">
                            <FaUsers className="icon" />
                            <span>More than 10k active users 🚀</span>
                        </div>
                    </div>
                    <div className="hero-right">
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/4140/4140048.png"
                            alt="Financial Solutions"
                        />
                    </div>
                </div>
            </section>

            {/* Services Grid */}
            <section className="services-grid">
                <h2 className="services-title">Our Services</h2>
                <div className="services-inner">
                    {services.map((service, index) => (
                        <div key={index} className="service-card enhanced-card">
                            <FaCheckCircle className="card-icon" />
                            <h3>{service.title}</h3>
                            <p>{service.desc}</p>
                            <ul className="service-benefits">
                                {service.benefits.map((benefit, i) => (
                                    <li key={i}> {benefit}</li>
                                ))}
                            </ul>
                            {service.interest && <p className="service-interest"><strong>Interest / Rate:</strong> {service.interest}</p>}
                            <a href="#" className="know-more">
                                Know more →
                            </a>
                        </div>
                    ))}
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="cta-inner">
                    <h2>Ready to secure your financial future?</h2>
                    <p>Join us today and take the first step towards financial freedom.</p>
                    <button className="btn-primary">Get started today</button>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-section">
                <div className="faq-inner">
                    <h2>You have questions, we have answers</h2>
                    <div className="faq-card">
                        <select>
                            <option>What types of loans do you offer?</option>
                            <option>How can I apply for a loan?</option>
                            <option>What documents are required?</option>
                            <option>How fast is the approval process?</option>
                        </select>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footerlanding />
        </div>
    );
};

export default ServicePage;